export { default } from './TextBanner';
export type { Props as TextBannerProps, BackgroundColorProp } from './TextBanner';
